import React from 'react';
import { Droplet, Shield, Sparkles, MapPin, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { HERO_IMAGE_URL } from '../../data/siteData';

export const Hero = () => {
  const navigate = useNavigate();
  return (
    <section id="accueil" className="relative pt-6 sm:pt-10 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-blue-50 to-white opacity-70"></div>

      {/* Water drops decoration */}
      <div className="absolute top-40 left-10 text-cyan-200 opacity-30">
        <Droplet className="h-24 w-24" fill="currentColor" />
      </div>
      <div className="absolute top-60 right-20 text-blue-200 opacity-20">
        <Droplet className="h-32 w-32" fill="currentColor" />
      </div>
      <div className="absolute bottom-20 left-1/4 text-blue-300 opacity-25">
        <Droplet className="h-16 w-16" fill="currentColor" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-blue-100 text-[#0205B3] px-4 py-2 rounded-full text-sm font-medium">
              <Sparkles className="h-4 w-4" />
              <span>2 Pressings Professionnels en Essonne : Longpont-sur-Orge & Mennecy</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Vos textiles
              <span className="block text-[#0205B3] mt-2">comme neufs</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              <strong>Nettoyage à sec de costumes, chemises, robes de mariée, robes de soirée, manteaux, cuir</strong> et tous vêtements délicats. <strong>Repassage, entretien literie (couettes, couvertures), nettoyage rideaux</strong>. Service rapide dans les Intermarché. <strong>2 établissements</strong> en Essonne (91) : <strong>Longpont-sur-Orge (91310)</strong> et <strong>Mennecy (91540)</strong>. Également <strong>spécialistes du nettoyage de tapis persan, oriental, kilim et moquettes</strong>.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button
                size="lg"
                className="bg-[#0205B3] hover:bg-[#0205B3]/90 text-white text-lg px-8 py-6"
                onClick={() => navigate('/services')}
                data-testid="hero-services-btn"
              >
                Découvrir nos services
                <ChevronRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-blue-500 text-[#0205B3] hover:bg-blue-50 text-lg px-8 py-6"
                onClick={() => navigate('/etablissements')}
                data-testid="hero-locations-btn"
              >
                Nous trouver
                <MapPin className="ml-2 h-5 w-5" />
              </Button>
            </div>

            <div className="flex items-center space-x-8 pt-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0205B3]">20+</div>
                <div className="text-sm text-gray-600">Ans d'expérience</div>
              </div>
              <div className="h-12 w-px bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0205B3]">100%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
              <div className="h-12 w-px bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0205B3]">Éco</div>
                <div className="text-sm text-gray-600">Responsable</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={HERO_IMAGE_URL}
                alt="Devanture PRESSING AQUABLUENET à Longpont-sur-Orge - Pressing écologique dans l'Intermarché Zac des Échassons 91310"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/30 to-transparent"></div>
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="bg-blue-100 rounded-full p-3">
                  <Shield className="h-6 w-6 text-[#0205B3]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Qualité garantie</div>
                  <div className="text-sm text-gray-600">Service professionnel certifié</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
